import React, {Component} from 'react';
import isEmpty from 'is-empty';
import {RealNumberRounded} from '../../../utils/NumeralParts';
import {isNil} from 'lodash';
import ArrayFormatters from '../../../utils/arrayFormatters';

const alertDetailsStyle = {
  width: "70%"
}

const alertButtonStyle = {
  display: "flex",
  justifyContent: "center",
  flexDirection: "row",
  margin: "auto"
}

class Alert extends Component {
  render() {
    const {id, filters, frequency} = this.props;
    const { keyword, region, regions } = filters;

    const regionsValue = isNil(regions) ? [region] : regions;

    const alert = {
      id: id,
      filters: filters,
      frequency: frequency
    }

    return (
      <div className="ds-card">
        <section className="cardSection _withColumns _padding--small">
          <div className="alert-details _padding--small" style={alertDetailsStyle}>
            <h4 className="copy">
              {`${keyword || "Projects"} in (${ArrayFormatters.toWords(regionsValue) || "All regions"})`}
            </h4>
            <div className="ds-data">
                <small><strong className="dataName">Frequency:</strong></small>
                <small className={`ds-status ${frequency === "daily" ? "-success" : "-primary"}`}>{frequency}</small>
              </div>
            <div className="ds-dataSet _parallelData">
              <div className="ds-data">
                <small><strong className="dataName">Minimum Amount:</strong></small>
                <small className="data">{isEmpty(filters.min_amount) ? "---" : `₱${RealNumberRounded({ number: filters.min_amount})}`}</small>
              </div>
              <div className="ds-data">
                <small><strong className="dataName">Maximum Amount:</strong></small>
                <small className="data">{isEmpty(filters.max_amount) ? "---" : `₱${RealNumberRounded({ number: filters.max_amount})}`}</small>
              </div>
            </div>
          </div>
          <div className="_centered --block" style={alertButtonStyle}>
            <button className="ds-btn --small"
              onClick={() => this.props.onClickUpdateButton(alert)}
              id={`${id}-edit-button`}
              data-testid="alert-edit-button"
            >
              <i className="materialIcon --small"> edit </i>
            </button>
            <button className="ds-btn --small -danger"
              onClick={() => this.props.onClickDeleteButton(alert)}
              id={`${id}-delete-button`}
              data-testid="alert-delete-button"
            >
              <i className="materialIcon --small" style={{color: "#fff"}}> delete </i>
            </button>
          </div>
        </section>
      </div>
    );
  }
}

export default Alert;



// WEBPACK FOOTER //
// ./src/features/alertsManager/components/AlertItem.js